// src/components/trip/PhotoUploadOverlay.tsx
import React from 'react';
import { View, Heading, Button, Flex } from '@aws-amplify/ui-react';
import { X } from 'lucide-react';
import PhotoUpload from '../PhotoUpload';

interface PhotoUploadOverlayProps {
  isOpen: boolean;
  tripId: string;
  onClose: () => void;
  onPhotoUploaded: (newPhoto: any) => void;
  userRole: string | null;
  onStorageLimitExceeded?: () => void;
}

const PhotoUploadOverlay: React.FC<PhotoUploadOverlayProps> = ({
  isOpen,
  tripId,
  onClose,
  onPhotoUploaded,
  userRole,
  onStorageLimitExceeded
}) => {
  if (!isOpen) return null;

  return (
    <div className="upload-overlay" onClick={onClose}>
      <div 
        className="upload-overlay-content" 
        onClick={e => e.stopPropagation()}
      >
        <Flex justifyContent="space-between" alignItems="center" marginBottom="1rem">
          <Heading
            level={3}
            style={{ color: "#fff" }}
          >
            Add Photos
          </Heading>
          <Button
            onClick={onClose}
            variation="link"
          >
            <X size={24} />
          </Button>
        </Flex>
        <PhotoUpload 
          tripId={tripId} 
          onPhotoUploaded={(photo) => {
            onPhotoUploaded(photo);
          }} 
          onClose={onClose} // Add this prop
          userRole={userRole}
          onStorageLimitExceeded={onStorageLimitExceeded}
        />
      </div>
    </div>
  );
};

export default PhotoUploadOverlay;